import LazyLoad from 'vanilla-lazyload';
import AOS from 'aos';

export default function () {
  AOS.init({
    offset: (window.innerHeight < 900) ? 50 : 100, // fade in earlier on mobile devices
    delay: 100,
    once: true
  });

  let initLazyLoadElements = function (lazyLoadSelector) {
    // ensuring (backward) compatibility for elements created for jquery unveil
    document.querySelectorAll('[data-src-retina]').forEach((el) => {
      // if higher resolution src is available, convert them in data-srcset for LazyLoad
      let srcSet = `${el.dataset.src} 1x, ${el.dataset.srcRetina} 2x`;
      if (!el.dataset.srcset) {
        el.dataset.srcset = srcSet;
      }
      // remove legacy attributes
      el.removeAttribute('data-src');
      el.removeAttribute('data-src-retina');
    });

    document.querySelectorAll(lazyLoadSelector).forEach((el) => {
      if (el.dataset.aos) {
        // we just need aos elements
        el.addEventListener('load', () => AOS.refresh());
      }
    });

    window.lazyLoadInstance = new LazyLoad({
      elements_selector: lazyLoadSelector,
      use_native: Boolean('loading' in HTMLImageElement.prototype)
    });
  };

  // convert legacy and init (AOS) elements with lazy loading
  initLazyLoadElements('.lazy-loading[data-src]:not([data-bg]),.lazy-loading[data-srcset]:not([data-bg]),.lazy-loading:not([data-bg])');
  // init lazyload without native support, which is require on lazy loading with data-bg
  new LazyLoad({
    elements_selector: '.lazy-loading[data-bg]',
    use_native: false
  });
}
